import React from 'react';
import WavesIcon from '@mui/icons-material/Waves';
import StrategyPage from '../components/legendary/StrategyPage';

export default function LegendaryTurtle() {
  return (
    <StrategyPage
      strategyKey="TURTLE"
      title="Turtle Donchian"
      icon={<WavesIcon />}
      color="#f97316"
    />
  );
}
